export const selectSearchLoading = (store) => store.search.loading;
export const selectSearchDrawerIsOpen = (store) => store.search.isOpen;
export const selectSearchErrors = (store) => store.search.errors;
export const selectSearchedData = (store) => store.search.data;
export const selectSearchValue = (store) => store.search.value;
